export default "__VITE_ASSET__B$e4Q$lT__"